<template>
  <div class="ProdDesc-container">
    <div class="gb-wrap">
      <div class="my-title">
        <div class="my-title-cn">产品介绍</div>
        <p class="my-title-en">PRODUCT DESCRIPTION</p>
      </div>
      <div class="my-cont clearfix">
        <div class="my-block invisible" v-for="(item, index) in items" :style="{ 'animation-delay': 0.2 * (index % 3) + 's' }" :key="index" js-ani-target>
          <div class="my-block-icon">
            <img :src="item.img" alt />
            <div class="my-shadow"></div>
          </div>
          <div class="my-block-title">
            <span>{{ item.title }}</span>
            <!-- <el-button size="mini" v-if="item.btn" class="my-block-btn" @click="$router.push('/player')">
              <span style="height:18px;line-height:18px;padding:0 10px;">正版音乐</span>
              <br />
              <span style="height:18px;line-height:18px;">点我试听</span>
            </el-button>-->
          </div>
          <p class="my-block-desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProdDesc',
  data() {
    return {
      items: [
        {
          title: '免费开发素材',
          desc: '提供优质大量的美术音频等免费开发素材，供开发者免费使用，方便开发者进行更多尝试',
          img: require('@/assets/prod_desc_1.png')
        },
        {
          title: '开源学习工程',
          desc: '提供多套开源学习工程，开发者可免费下载，查看工程细节，进行编程学习',
          img: require('@/assets/prod_desc_2.png')
        },
        // {
        //   title: '基础游戏模板',
        //   desc: '用户可直接下载木夕提供的游戏模板，跟随模板提示，创作自己的游戏项目',
        //   img: require('@/assets/prod_desc_3.png')
        // },
        // {
        //   title: '金牌视频教程',
        //   desc: '大量金牌创作教程，包你从小白变成大神，用户可随时在教程中心学习',
        //   img: require('@/assets/prod_desc_4.png')
        // },
        {
          title: '多端平台运行',
          desc: '逻辑积木可同时在Windows、MAC、移动端平台运行，时刻保持开发环境',
          img: require('@/assets/prod_desc_5.png')
        },
        // {
        //   title: '资源曝光计划',
        //   desc: '我们将协助优秀UGC作品和作者得到更好的资源，圆每一个千里马的游戏梦',
        //   img: require('@/assets/prod_desc_6.png')
        //   // btn: true
        // }
      ]
    }
  },
  created() {
    window.addEventListener('scroll', this.scrollListener)
  },
  mounted() {
    this.scrollListener()
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    removeListener() {
      window.removeEventListener('scroll', this.scrollListener)
    },
    scrollListener() {
      let flag = true
      let arr = Array.from(this.$el.querySelectorAll('[js-ani-target]'))
      if (arr.length > 0) {
        arr.forEach(d => {
          if (this.$utils.isInViewPort(d)) {
            d.classList.add('animated', 'rotateIn')
            d.classList.remove('invisible')
          }
          flag = flag && d.classList.contains('animated')
        })
        if (flag) this.removeListener()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ProdDesc-container {
  overflow: hidden;
}

.my-title {
  padding-top: 95px;
  padding-bottom: 30px;
}

.my-title-cn {
  font-size: 40px;
  color: #333333;
  line-height: 70px;
}

.my-title-en {
  margin-top: 10px;
  font-size: 22px;
  color: rgba(#58627c, 0.5);
}

.my-cont {
  padding-bottom: 150px;
  display: flex;
  justify-content: space-between;
  flex-wrap:  wrap ;
}

.my-block {
  // float: left;
  flex: 1;
  min-width: 33.33%;
  max-width: 33.33%;
  width: 33.33%;
  margin-top: 60px;
  text-align: center;
  &:nth-child(3n + 1) {
    padding-right: 60px;
  }
  &:nth-child(3n) {
    padding-left: 60px;
  }
}

.my-block-icon {
  text-align: center;
  overflow: hidden;
  img {
    width: 68px;
    height: 68px;
  }
}

.my-shadow {
  width: 40px;
  height: 10px;
  margin: 10px auto;
  background: #d8d8d8;
  border-radius: 50%;
}

.my-block-title {
  margin: 10px 0;
  line-height: 42px;
  font-size: 30px;
  color: #333333;
  // letter-spacing: 0.22px;
}
.my-block-btn {
  display: inline-block;
  font-size: 0.5em;
  line-height: 1;
  vertical-align: middle;
  margin-left: 1em;
  padding: 0.3em;
  background: rgb(75, 133, 255);
  color: #fff;
  cursor: pointer;
}

.my-block-desc {
  font-size: 18px;
  color: #666666;
  // letter-spacing: 0.32px;
  line-height: 28px;
}
</style>
